<div class="lp-wrapper">
  <div *ngIf="loading" class="lp-status">Loading…</div>
  <div *ngIf="!loading && errorMsg" class="lp-status lp-error">{{ errorMsg }}</div>

  <ngx-charts-bar-horizontal-2d
    *ngIf="!loading && !errorMsg && !useStacked"
    [results]="chartData"
    [view]="viewsize"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [legend]="showLegend"
  [customColors]="customColors"
  [barPadding]="1"
  [groupPadding]="12"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [trimXAxisTicks]="false"
    [trimYAxisTicks]="false"
    [yAxisTickFormatting]="formatVideoLabel">
  </ngx-charts-bar-horizontal-2d>

  <ngx-charts-bar-horizontal-stacked
    *ngIf="!loading && !errorMsg && useStacked"
    [results]="chartData"
    [view]="viewsize"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [legend]="showLegend"
    [customColors]="customColors"
    [barPadding]="1"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [trimXAxisTicks]="false"
    [trimYAxisTicks]="false"
    [yAxisTickFormatting]="formatVideoLabel">
  </ngx-charts-bar-horizontal-stacked>
</div>
